module.exports = __webpack_public_path__ + "static/media/connect.8f1f796e.svg";